import {
  Button,
  Card,
  Table,
  Space,
  notification,
  Form,
  Upload,
  Modal,
  Input,
  Select,
  Row,
  Col,
} from "antd";
import { UploadOutlined, DeleteOutlined } from "@ant-design/icons";
import AWS from "aws-sdk";
import { useEffect, useState } from "react";
import { API } from "../../config/api";
import { DELETE, GET, POST } from "../../utils/apicalls";
import LoadingAnimation from "../../componets/loader/loader";
import { useNavigate } from "react-router-dom";




function ProductManagement() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [meta, setMeta] = useState<any>({});
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoryData, setCategoryData] = useState<any>([]);
  const [subcategoryData, setsubCategoryData] = useState<any>([]);
  const [ProductData, setProductData] = useState<any>([]);
  const [Productfilter, setProductfilterData] = useState<any>([]);
  const [clientData, setclientData] = useState<any>([]);
  const navigate = useNavigate();

  // Changed to array to store multiple images
  const [productImages, setProductImages] = useState<string[]>([]);
  const [uploadingImages, setUploadingImages] = useState<boolean>(false);
  interface AwsData {
    accessKeyId?: string;
    secretAccessKey?: string;
    region?: string;
    [key: string]: any;
  }
  const [awsData, setawsData] = useState<AwsData>({});
  const s3 = new AWS.S3({
    accessKeyId: awsData.accessKeyId,
    secretAccessKey: awsData.secretAccessKey,
    region: awsData.region,
  });
  const fetchawsDetails = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.AWS_KEY, {}); // This should return the above JSON
      if (response && response.accessKeyId) {
        setawsData(response); // Not response.data
      } else if (response?.data?.accessKeyId) {
        setawsData(response.data); // If using Axios-style
      } else {
        console.warn("AWS credentials not found in response", response);
      }
    } catch (error) {
      console.error("Failed to fetch AWS credentials", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (awsData.accessKeyId && awsData.secretAccessKey && awsData.region) {
      AWS.config.update({
        accessKeyId: awsData.accessKeyId,
        secretAccessKey: awsData.secretAccessKey,
        region: awsData.region,
      });
    }
  }, [awsData]);
  useEffect(() => {
    fetchawsDetails();
  }, []);
  const S3_BUCKET = awsData?.bucketName;

  const fetchCategories = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.LISTING_GET_CATEGORY, {});
      setCategoryData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchProductsGet = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.PRODUCT_GET_LISTING, {});
      setProductData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchProductsGet();
    fetchClient();
    fetchProducts(page, pageSize);
  }, [page, pageSize]);

  // Enhanced multiple file upload handler
  const handleMultipleFileUpload = async (fileList: any[]) => {
    if (fileList.length === 0) return;

    // Limit to 4 images maximum
    const filesToUpload = fileList.slice(0, 4);
    setUploadingImages(true);

    try {
      const uploadPromises = filesToUpload.map((file, index) => {
        return new Promise((resolve, reject) => {
          const params = {
            Bucket: S3_BUCKET,
            Key: `product/images/${Date.now()}_${index}_${file.name}`,
            Body: file,
            ContentType: file.type,
          };

          s3.upload(params, (err: any, data: any) => {
            if (err) {
              reject(err);
            } else {
              resolve(data.Location);
            }
          });
        });
      });

      const uploadedUrls = await Promise.all(uploadPromises);
      setProductImages(uploadedUrls as string[]);

      // Set form values for backward compatibility
      uploadedUrls.forEach((url, index) => {
        form.setFieldsValue({ [`productImage${index + 1}`]: url });
      });

      notification.success({
        message: `${uploadedUrls.length} image(s) uploaded successfully!`
      });
    } catch (error) {
      console.error('Upload error:', error);
      notification.error({ message: "Some images failed to upload!" });
    } finally {
      setUploadingImages(false);
    }
  };

  // Remove specific image
  const removeImage = (indexToRemove: number) => {
    const updatedImages = productImages.filter((_, index) => index !== indexToRemove);
    setProductImages(updatedImages);

    // Update form values
    for (let i = 1; i <= 4; i++) {
      form.setFieldsValue({ [`productImage${i}`]: updatedImages[i - 1] || null });
    }
  };

  // Multiple upload props
  const getMultipleUploadProps = () => ({
    name: "files",
    multiple: true,
    accept: "image/*",
    showUploadList: false,
    beforeUpload: (file: any, fileList: any[]) => {
      // Check file size (limit to 5MB per file)
      if (file.size > 5 * 1024 * 1024) {
        notification.error({ message: `${file.name} is too large. Maximum size is 5MB.` });
        return false;
      }

      // Check file type
      if (!file.type.startsWith('image/')) {
        notification.error({ message: `${file.name} is not an image file.` });
        return false;
      }

      // Check total number of files
      if (productImages.length + fileList.length > 4) {
        notification.warning({ message: "Maximum 4 images allowed. Excess files will be ignored." });
      }

      return false; // Prevent automatic upload
    },
    onChange: (info: any) => {
      const fileList = info.fileList.map((file: any) => file.originFileObj).filter(Boolean);
      if (fileList.length > 0) {
        handleMultipleFileUpload(fileList);
      }
    },
  });

  const fetchProducts = async (currentPage: number, currentPageSize: number) => {
    try {
      setIsLoading(true);
      const obj = {
        query: "query",
        page: currentPage,
        take: currentPageSize,
      };

      const url = API.LIST_PRODUCT;
      const response: any = await POST(url, obj);

      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchClient = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.GET_LISTING_CLIENT_DATA, {});
      setclientData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id: any) => {
    try {
      setIsLoading(true);
      const delete_customer_url = `${API.DELETE_PRODUCT}${id}`;
      const data: any = await DELETE(delete_customer_url);

      if (data.status) {
        notification.success({ message: "Product deleted successfully!" });
        fetchProducts(page, pageSize);
      } else {
        notification.error({
          message: "Something went wrong! Please try again later.",
        });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDelete = (id: any) => {
    const confirm = window.confirm("Are you sure you want to delete this?");
    if (confirm) {
      handleDelete(id);
    }
  };

  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      render: (_: any, __: any, index: number) => index + 1,
    },
    { title: "Product Title", dataIndex: "productTitle" },
    {
      title: "Product Images",
      dataIndex: "productImage1",
      render: (_: any, record: any) => (
        <div style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
          {[record.productImage1, record.productImage2, record.productImage3, record.productImage4]
            .filter(Boolean)
            .map((url, index) => (
              <img
                key={index}
                src={url}
                alt={`Product ${index + 1}`}
                style={{ width: 50, height: 50, objectFit: "cover", borderRadius: "4px" }}
              />
            ))}
        </div>
      ),
    },
    { title: "Description", dataIndex: "descriptionProduct" },
    { title: "Brand", dataIndex: "brand" },
    { title: "Color", dataIndex: "color" },
    { title: "Gender", dataIndex: "gender" },
    { title: "Size", dataIndex: "size" },
    { title: "Price", dataIndex: "Price" },
    { title: "Shipping", dataIndex: "shipping" },
    { title: "Stock", dataIndex: "stock_product" },
    {
      title: "Client",
      dataIndex: "clientId",
      render: (clientId: number, record: any) =>
        clientId ? record?.client_Id?.clientName : "Admin",
    },
    {
      title: "Category",
      dataIndex: "category_id",
      render: (_: any, record: any) => (
        <span>{record?.categoryid?.categoryTitle}</span>
      ),
    },
    {
      title: "Sub Category",
      dataIndex: "Subcategory_id",
      render: (_: any, record: any) => (
        <span>{record?.subcategoryid?.SubcategoryTitle}</span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button type="link" onClick={() => confirmDelete(record.id)}>
            Delete
          </Button>
          <Button
            type="link"
            onClick={() =>
              navigate(`/Admin/adminProduct/updateproduct/${record.id}`)
            }
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];
  const submitHandler = async (values: any) => {
    try {
      // Step 1️⃣: Prepare product data
      const obj = {
        ...values,
        Price: Number(values.Price),
        productImage1: productImages[0] || null,
        productImage2: productImages[1] || null,
        productImage3: productImages[2] || null,
        productImage4: productImages[3] || null,
        stock_product: "stock in",
      };

      setIsLoading(true);

      // Step 2️⃣: Create Product
      const productRes: any = await POST(API.CREATE_PRODUCT, obj);

      if (productRes.status && productRes.data?.id) {
        const productId = productRes.data.id;
        const variants = values.variants || [];

        // Step 3️⃣: Create variants one by one
        if (variants.length > 0) {
          for (const variant of variants) {
            const variantObj = {
              productId: productId,
              variantName: variant.variantName,
              variantprice: Number(variant.variantprice),
            };

            // ⚠️ Replace this API with your actual variant creation endpoint
            await POST(API.CREATE_PRODUCT_VARIANT, variantObj);
          }
        }

        // Step 4️⃣: Notify success
        notification.success({
          message: "Product and variants added successfully!",
        });

        // Step 5️⃣: Reset form and UI
        form.resetFields();
        setProductImages([]);
        setIsModalOpen(false);
        fetchProducts(page, pageSize);
      } else {
        notification.error({
          message: "Failed to create product",
        });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const filtersubCategoryData = async (categoryId: number) => {
    try {
      setIsLoading(true);
      const api = API.FILTER_SUBCATEGORY;
      const response: any = await POST(api, { category_id: categoryId });

      if (response?.data) {
        setsubCategoryData(response?.data);
      } else {
        console.error("Data not available:", response);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <div className="banner-container">
        {isLoading ? (
          <LoadingAnimation />
        ) : (
          <div className="banner-content">
            <h1 className="banner-title">Product Management</h1>
            <button
              className="banner-button"
              onClick={() => setIsModalOpen(true)}
            >
              Create Product
            </button>
          </div>
        )}
      </div>

      <Card>
        <Table
          columns={columns}
          dataSource={Productfilter.length ? Productfilter : data}
          loading={isLoading}
          pagination={{
            current: page,
            pageSize: pageSize,
            total: meta?.total,
            showSizeChanger: true,
            onChange: (newPage, newPageSize) => {
              setPage(newPage);
              setPageSize(newPageSize);
              fetchProducts(newPage, newPageSize);
            },
          }}
          rowKey={(record: any) => record.id}
          scroll={{ x: "max-content" }}
        />
      </Card>

      <Modal
        title="Add Product"
        visible={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setProductImages([]);
          form.resetFields();
        }}
        footer={null}
        width="70%"
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="productTitle"
                label="Product Title"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="brand" label="Brand">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="shipping" label="Shipping">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="color" label="Color">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="descriptionProduct"
                label="Description"
                rules={[{ required: true }]}
              >
                <Input.TextArea autoSize={{ minRows: 3, maxRows: 8 }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="size" label="Size">
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="gender"
                label="Gender"
                rules={[{ required: true }]}
              >
                <Select placeholder="Select Gender">
                  <Select.Option value="male">Male</Select.Option>
                  <Select.Option value="female">Female</Select.Option>
                  <Select.Option value="other">Other</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="Price"
                label="Price"
                rules={[{ required: true }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="category_id"
                label="Category"
                rules={[{ required: true }]}
              >
                <Select
                  placeholder="Select a category"
                  onChange={(value) => {
                    form.setFieldsValue({ subCategory: undefined });
                    filtersubCategoryData(value);
                  }}
                  loading={isLoading}
                >
                  {categoryData?.map((category: any) => (
                    <Select.Option key={category.id} value={category.id}>
                      {category.categoryTitle}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="Subcategory_id"
                label="SubCategory"
                rules={[{ required: true }]}
              >
                <Select placeholder="Select a subcategory" loading={isLoading}>
                  {subcategoryData?.map((sub: any) => (
                    <Select.Option key={sub.id} value={sub.id}>
                      {sub.SubcategoryTitle}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.List name="variants">
            {(fields, { add, remove }) => (
              <>
                <h4>Product Variants</h4>
                {fields.map(({ key, name, ...restField }) => (
                  <Row gutter={16} key={key}>
                    <Col span={10}>
                      <Form.Item
                        {...restField}
                        name={[name, "variantName"]}
                        label="Variant Name"
                        rules={[{ required: true, message: "Enter variant name" }]}
                      >
                        <Input placeholder="e.g. XL or 1kg" />
                      </Form.Item>
                    </Col>
                    <Col span={10}>
                      <Form.Item
                        {...restField}
                        name={[name, "variantprice"]}
                        label="Variant Price"
                        rules={[{ required: true, message: "Enter price" }]}
                      >
                        <Input type="number" placeholder="Price" />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Button danger onClick={() => remove(name)}>Remove</Button>
                    </Col>
                  </Row>
                ))}

                <Button type="dashed" onClick={() => add()} block>
                  + Add Variant
                </Button>
              </>
            )}
          </Form.List>

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label="Product Images (Max 4)">
                <Upload {...getMultipleUploadProps()}>
                  <Button
                    icon={<UploadOutlined />}
                    loading={uploadingImages}
                    disabled={productImages.length >= 4}
                  >
                    {uploadingImages ? 'Uploading...' : 'Select Multiple Images'}
                  </Button>
                </Upload>
                <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                  • Select up to 4 images at once
                  • Supported formats: JPG, PNG, GIF
                  • Maximum size: 5MB per image
                </div>
              </Form.Item>
            </Col>
          </Row>

          {/* Display uploaded images */}
          {productImages.length > 0 && (
            <Row gutter={16}>
              <Col span={24}>
                <div style={{ marginBottom: '20px' }}>
                  <h4>Uploaded Images ({productImages.length}/4)</h4>
                  <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                    {productImages.map((imageUrl, index) => (
                      <div key={index} style={{ position: 'relative' }}>
                        <img
                          src={imageUrl}
                          alt={`Product ${index + 1}`}
                          style={{
                            width: '100px',
                            height: '100px',
                            objectFit: 'cover',
                            borderRadius: '8px',
                            border: '1px solid #d9d9d9'
                          }}
                        />
                        <Button
                          type="text"
                          danger
                          size="small"
                          icon={<DeleteOutlined />}
                          onClick={() => removeImage(index)}
                          style={{
                            position: 'absolute',
                            top: '-5px',
                            right: '-5px',
                            background: '#ff4d4f',
                            color: 'white',
                            borderRadius: '50%',
                            width: '20px',
                            height: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>
          )}

          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
}

export default ProductManagement;